import * as ImagePicker from 'expo-image-picker';

/** Soft cap for legacy base64 JSON uploads; large videos use chunked upload-session. */
export const UPLOAD_BINARY_MAX_BYTES = 450 * 1024 * 1024;

export function bytesFromBase64(b64) {
  if (!b64 || typeof b64 !== 'string') return 0;
  const len = b64.length;
  const padding = b64.endsWith('==') ? 2 : b64.endsWith('=') ? 1 : 0;
  return Math.max(0, Math.floor((len * 3) / 4) - padding);
}

export function formatVideoSizeMb(bytes) {
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * @param {number} bytes
 * @returns {string|null} User message if too large
 */
export function videoTooLargeMessage(bytes) {
  if (!bytes || bytes <= UPLOAD_BINARY_MAX_BYTES) return null;
  return (
    `Video is about ${formatVideoSizeMb(bytes)}. Maximum is ${formatVideoSizeMb(UPLOAD_BINARY_MAX_BYTES)}. ` +
    'Trim or compress the video, or use a YouTube link instead.'
  );
}

/** Short break uploads — optional 60s cap keeps clips smaller. */
export function getYoutubeVideoPickerOptions() {
  return {
    mediaTypes: ImagePicker.MediaTypeOptions.Videos,
    allowsEditing: false,
    quality: 1,
    base64: true,
    videoMaxDuration: 60,
  };
}

/** Exercise Builder — no duration cap; URI-only (no base64) on device. */
export function getExerciseVideoPickerOptions() {
  return {
    mediaTypes: ImagePicker.MediaTypeOptions.Videos,
    allowsEditing: false,
    quality: 1,
  };
}

/**
 * @param {{ fileSize?: number, base64?: string }} source
 * @returns {string|null}
 */
export function assertVideoUploadable(source) {
  const bytes =
    source?.fileSize > 0 ? source.fileSize : bytesFromBase64(source?.base64);
  return videoTooLargeMessage(bytes);
}
